<template>
  <section :class="{ 'animated-section': true, 'section-active': ready }" style="overflow: hidden">
    <div class="page-title">
      <h2>Contact</h2>
    </div>

    <div class="section-content">
      <div class="row">
        <!-- Contact Info -->
        <div class="col-xs-12 col-sm-4">
          <div class="lm-info-block gray-default">
            <i class="lnr lnr-map-marker"></i>
            <h4>{{ data.home }}</h4>
            <span class="lm-info-block-value"></span>
            <span class="lm-info-block-text"></span>
          </div>

          <div class="lm-info-block gray-default">
            <i class="lnr lnr-phone-handset"></i>
            <h4>
              <a :href="`tel:${data.phone.id}`" class="__cf_email__" style="font-size: 13px">
                {{ data.phone.view }}
              </a>
            </h4>
            <span class="lm-info-block-value"></span>
            <span class="lm-info-block-text"></span>
          </div>

          <div class="lm-info-block gray-default">
            <i class="lnr lnr-envelope"></i>
            <h4>
              <a :href="`mailto:${data.email}`" class="__cf_email__" style="font-size: 13px">
                <div style="line-height: 13px">aacassandra@programmer.net</div>
              </a>
            </h4>
            <span class="lm-info-block-value"></span>
            <span class="lm-info-block-text"></span>
          </div>

          <div class="lm-info-block gray-default">
            <i class="lnr lnr-checkmark-circle"></i>
            <h4>Freelance Available</h4>
            <span class="lm-info-block-value"></span>
            <span class="lm-info-block-text"></span>
          </div>
        </div>
        <!-- End of Contact Info -->

        <!-- Contact Form -->
        <div class="col-xs-12 col-sm-8">
          <div id="map" class="map">
            <div class="lmpixels-map">
              <iframe
                frameborder="0"
                scrolling="no"
                marginheight="0"
                marginwidth="0"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5998.657344454825!2d112.77077709317268!3d-7.237552783786148!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd7f9a50e17d849%3A0xa896a273270b6d93!2s002%2C%20Jl.%20Kapas%20Gading%20Madya%20IIA%20No.26%2C%20RW.21%2C%20Gading%2C%20Kec.%20Tambaksari%2C%20Kota%20SBY%2C%20Jawa%20Timur%2060134!5e0!3m2!1sen!2sid!4v1621967309954!5m2!1sen!2sid"
              ></iframe>
            </div>
          </div>
          <div class="block-title">
            <h3>How Can I <span>Help You?</span></h3>
          </div>

          <form
            id="contact_form"
            class="contact-form"
            action="https://lmpixels.com/demo/breezycv/dark/3/contact_form/contact_form.php"
            method="post"
          >
            <div class="messages"></div>

            <div class="controls two-columns">
              <div class="fields clearfix">
                <div class="left-column">
                  <div class="form-group form-group-with-icon">
                    <input
                      id="form_name"
                      type="text"
                      name="name"
                      class="form-control"
                      placeholder=""
                      required="required"
                      data-error="Name is required."
                    />
                    <label>Full Name</label>
                    <div class="form-control-border"></div>
                    <div class="help-block with-errors"></div>
                  </div>

                  <div class="form-group form-group-with-icon">
                    <input
                      id="form_email"
                      type="email"
                      name="email"
                      class="form-control"
                      placeholder=""
                      required="required"
                      data-error="Valid email is required."
                    />
                    <label>Email Address</label>
                    <div class="form-control-border"></div>
                    <div class="help-block with-errors"></div>
                  </div>

                  <div class="form-group form-group-with-icon">
                    <input
                      id="form_subject"
                      type="text"
                      name="subject"
                      class="form-control"
                      placeholder=""
                      required="required"
                      data-error="Subject is required."
                    />
                    <label>Subject</label>
                    <div class="form-control-border"></div>
                    <div class="help-block with-errors"></div>
                  </div>
                </div>
                <div class="right-column">
                  <div class="form-group form-group-with-icon">
                    <textarea
                      id="form_message"
                      name="message"
                      class="form-control"
                      placeholder=""
                      rows="7"
                      required="required"
                      data-error="Please, leave me a message."
                    ></textarea>
                    <label>Message</label>
                    <div class="form-control-border"></div>
                    <div class="help-block with-errors"></div>
                  </div>
                </div>
              </div>

              <div
                class="g-recaptcha"
                data-sitekey="6LdqmCAUAAAAAMMNEZvn6g4W5e0or2sZmAVpxVqI"
                data-theme="dark"
              ></div>

              <input type="submit" class="button btn-send" value="Send message" />
            </div>
          </form>
        </div>
        <!-- End of Contact Form -->
      </div>
    </div>
  </section>
</template>
<script>
import { inject, onBeforeUnmount, onMounted, ref } from 'vue'

export default {
  setup() {
    const scrollbar = inject('scrollbar')
    const ready = ref(false)
    const data = inject('data')

    onMounted(() => {
      ready.value = true
      setTimeout(() => {
        scrollbar.enabled = true
        scrollbar.init = true
      }, 500)
    })

    onBeforeUnmount(() => {
      ready.value = false
      scrollbar.enabled = false
    })

    return { data, ready }
  }
}
</script>
